/**
 * 配送模块 PDF：与后端导出接口同一模板，支持下载与浏览器打印。
 */

async function parsePdfBlob (blobData) {
  if (!(blobData instanceof Blob)) {
    throw new Error('响应格式异常')
  }
  if (blobData.type && blobData.type.includes('application/json')) {
    const text = await blobData.text()
    let msg = '请求失败'
    try {
      const obj = JSON.parse(text)
      msg = obj.message || obj.msg || msg
    } catch (e) { /* ignore */ }
    throw new Error(msg)
  }
  return new Blob([blobData], { type: 'application/pdf' })
}

export async function downloadPdfBlob (blobData, downloadName) {
  const blob = await parsePdfBlob(blobData)
  const link = document.createElement('a')
  link.href = URL.createObjectURL(blob)
  link.download = downloadName
  link.click()
  URL.revokeObjectURL(link.href)
}

function invokePrint (targetWindow, onDone) {
  if (!targetWindow || targetWindow.closed) {
    onDone(new Error('打印窗口已关闭'))
    return
  }
  try {
    targetWindow.focus()
    targetWindow.print()
    onDone(null)
  } catch (e) {
    onDone(e)
  }
}

/**
 * 打开 PDF 并调起打印（与导出同一文件）。
 * 优先新窗口直开 blob；失败时用带尺寸的离屏 iframe + embed。
 */
export function printPdfBlob (blobData) {
  return parsePdfBlob(blobData).then(blob => {
    const url = URL.createObjectURL(blob)
    const revokeLater = () => setTimeout(() => URL.revokeObjectURL(url), 120000)

    return new Promise((resolve, reject) => {
      const finish = (err) => {
        revokeLater()
        if (err) reject(err)
        else resolve()
      }

      const printWin = window.open('', '_blank')
      if (printWin) {
        printWin.document.open()
        printWin.document.write(
          '<!DOCTYPE html><html><head><meta charset="utf-8"><title>打印</title></head>' +
          '<body style="margin:0;height:100vh">' +
          '<embed type="application/pdf" src="' + url + '" width="100%" height="100%" ' +
          'style="display:block;min-height:100vh" /></body></html>'
        )
        printWin.document.close()
        setTimeout(() => invokePrint(printWin, finish), 1200)
        return
      }

      // 弹窗被拦截：离屏但非 0 尺寸，否则 Chrome 不渲染 PDF
      const holder = document.createElement('div')
      holder.setAttribute('aria-hidden', 'true')
      holder.style.cssText = 'position:fixed;left:-10000px;top:0;width:794px;height:1123px;overflow:hidden'
      const iframe = document.createElement('iframe')
      iframe.setAttribute('title', 'print')
      iframe.style.cssText = 'width:794px;height:1123px;border:0'
      holder.appendChild(iframe)
      document.body.appendChild(holder)

      const cleanup = () => {
        if (holder.parentNode) {
          holder.parentNode.removeChild(holder)
        }
      }

      iframe.onload = () => {
        setTimeout(() => {
          invokePrint(iframe.contentWindow, (err) => {
            cleanup()
            finish(err)
          })
        }, 600)
      }
      iframe.onerror = () => {
        cleanup()
        finish(new Error('加载打印内容失败'))
      }
      iframe.src = url
    })
  })
}

export function exportPdfFilename (prefix) {
  const now = new Date()
  const pad = n => String(n).padStart(2, '0')
  const stamp = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`
  return `${prefix}_${stamp}.pdf`
}
